var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "family"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33331 3.33333C3.33331 3.68696 3.47379 4.02609 3.72384 4.27614C3.97389 4.52619 4.31302 4.66667 4.66665 4.66667C5.02027 4.66667 5.35941 4.52619 5.60946 4.27614C5.8595 4.02609 5.99998 3.68696 5.99998 3.33333C5.99998 2.97971 5.8595 2.64057 5.60946 2.39052C5.35941 2.14048 5.02027 2 4.66665 2C4.31302 2 3.97389 2.14048 3.72384 2.39052C3.47379 2.64057 3.33331 2.97971 3.33331 3.33333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.33335 14.6666V11.3333L2.66669 10.6666V7.99998C2.66669 7.82317 2.73693 7.6536 2.86195 7.52858C2.98697 7.40355 3.15654 7.33331 3.33335 7.33331H6.00002C6.17683 7.33331 6.3464 7.40355 6.47142 7.52858C6.59645 7.6536 6.66669 7.82317 6.66669 7.99998V10.6666L6.00002 11.3333V14.6666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10 3.33333C10 3.68696 10.1405 4.02609 10.3905 4.27614C10.6406 4.52619 10.9797 4.66667 11.3333 4.66667C11.687 4.66667 12.0261 4.52619 12.2761 4.27614C12.5262 4.02609 12.6667 3.68696 12.6667 3.33333C12.6667 2.97971 12.5262 2.64057 12.2761 2.39052C12.0261 2.14048 11.687 2 11.3333 2C10.9797 2 10.6406 2.14048 10.3905 2.39052C10.1405 2.64057 10 2.97971 10 3.33333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10 14.6666V12H8.66669L10 7.99998C10 7.82317 10.0703 7.6536 10.1953 7.52858C10.3203 7.40355 10.4899 7.33331 10.6667 7.33331H12C12.1768 7.33331 12.3464 7.40355 12.4714 7.52858C12.5964 7.6536 12.6667 7.82317 12.6667 7.99998L14 12H12.6667V14.6666",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.7815daa896303ee79cda3c1af512d0ae.svg";
export { ForwardRef as ReactComponent };